import { useEffect } from 'react';
import {
  PlaidLinkOnEvent,
  PlaidLinkOnExit,
  PlaidLinkOnSuccess,
  usePlaidLink,
} from 'react-plaid-link';

import LoaderOverlay from 'components/PageLayout/LoaderOverlay';

interface IPlaidWidgetProps {
  onSuccessAction: PlaidLinkOnSuccess;
  onExitAction: PlaidLinkOnExit;
  onEventAction: PlaidLinkOnEvent;
  linkToken: string;
}

const PlaidWidget = ({
  onExitAction,
  onSuccessAction,
  linkToken,
  onEventAction,
}: IPlaidWidgetProps) => {
  const { ready, open } = usePlaidLink({
    onSuccess: onSuccessAction,
    onExit: onExitAction,
    onEvent: onEventAction,
    token: linkToken,
  });

  useEffect(() => {
    if (ready) {
      open();
    }
  }, [ready]);

  if (!ready) {
    return <LoaderOverlay />;
  }

  return null;
};

export default PlaidWidget;
